import getReviews from './getReviews';
import verifyReview from './verifyReview';
import removeReview from './removeReview';
import getReviewReport from './getReviewReport';

export default {
  getReviews,
  verifyReview,
  removeReview,
  getReviewReport,
};
